import React, { memo } from "react";

const Footer = () => {
  const isMobile = window.innerWidth <= 640;
  const isTablet = window.innerWidth <= 1024;

  return (
    <footer
      style={{
        padding: isMobile ? "15px 10px" : isTablet ? "20px 15px" : "20px",
        textAlign: "center",
        backgroundColor: "#1e293b",
        color: "#fff",
        fontSize: isMobile ? "0.85rem" : isTablet ? "0.9rem" : "0.95rem",
        marginTop: "auto",
        borderTop: "1px solid #334155",
        display: "flex",
        flexDirection: "column",
        gap: isMobile ? "8px" : "12px",
      }}
    >
      <p style={{ margin: 0 }}>
        © {new Date().getFullYear()} SARLearn. All rights reserved.
      </p>
      
      {/* Optional: Add responsive footer links */}
      <div style={{
        display: "flex",
        gap: isMobile ? "10px" : "20px",
        justifyContent: "center",
        flexWrap: "wrap",
        fontSize: isMobile ? "0.8rem" : "0.9rem",
      }}>
        <a href="/" style={{ color: "#60a5fa", textDecoration: "none" }}>Privacy Policy</a>
        <span style={{ color: "#64748b" }}>•</span>
        <a href="/" style={{ color: "#60a5fa", textDecoration: "none" }}>Terms of Service</a>
        <span style={{ color: "#64748b" }}>•</span>
        <a href="/" style={{ color: "#60a5fa", textDecoration: "none" }}>Contact</a>
      </div>
    </footer>
  );
};

export default memo(Footer);